export default {
  Account: {
    AuthenticateInformation: 'Xác thực thông tin',
    EnterVerificationCodeSent: 'Vui lòng nhập mã xác thực được gửi đến',
    NotReceivedCode: 'Bạn không nhận được mã',
    SendAgain: 'Gửi lại',
    PhoneNumber: 'số điện thoại',
    NotEnoughCode: 'Bạn chưa nhập đủ mã',
    CodeIncorrect: 'Mã xác thực không chính xác',
    PhoneNumberInValid: 'Số điện thoại không hợp lệ'
  }
}
